import {
  makeStyles,
  TextField,
  Typography,
} from '@material-ui/core';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  title: {
    padding: '0 6px',
    fontSize: 12,
  },
  searchInput: {
    width: '100%',
    height: 50,
  },
  search: {},
  mainContainer: {
    width: '100%',
    height: 36,
  },
}));

const inputStyle = {
  height: '36px',
  lineHeight: '14px',
  fontSize: '14px',
  borderWidth: 2,
  borderStyle: 'inset',
  borderColor: 'rgba(244, 244, 255, 0.01)',
};

const Search = ({
                  searchValue,
                  setSearchValue,
                }) => {
  const classes = useStyles();
  const { en: { titles } } = useSelector((state) => state.i18n);

  return <div className={classes.mainContainer}>
    <Typography className={classes.title}>
      {titles.search}
    </Typography>
    <TextField
      size={'small'}
      className={classes.searchInput}
      label='Search'
      variant={'outlined'}
      autoFocus={true}
      style={inputStyle}
      InputLabelProps={{ style: inputStyle }}
      inputProps={{ style: { ...inputStyle, padding: '0 14px' } }}
      classes={{
        root: classes.search,
        input: classes.search,
      }}
      value={searchValue}
      onChange={(e) => setSearchValue(e.target.value)}
    />
  </div>;
};

export default Search;
